<div class="wccard p-3 gray-border">
  <div class="d-flex justify-content-between mb-3 text-defualt"><span class="font-weight-600">Find Ideal Candidates</span>  <span class="f-14 font-weight-600 pointer" (click)="modalService.dismissAll()">
      <span><i class=" fa-solid fa-times"></i></span>
  </span>
  </div>
  <div class="d-flex align-items-center mb-3">
    <div class="linkedin-label">
      <i class="fa fa-linkedin-square"></i>
    </div>
    <div>
      <p class="f-12 font-weight-500" style="margin-bottom: 3px;">LinkedIn Profile</p>
      <p class="f-12 text-9696 mb-0">Share the LinkedIn Profile of your benchmark candidate and we’ll show you similar
        profiles.</p>
    </div>
  </div>
  <div class="mb-4">
    <input data-testid="auto-app-similar-candidates-input-1" type="text" class="wc-form-control nobg" placeholder="Paste linkedin URL" [(ngModel)]="linkedinurl"
      (ngModelChange)="onLinkedinUrlChange($event)" [disabled]="uploadedFilename"
      [ngClass]="{'bggraywhilefileuploaded':uploadedFilename}">
    <p class="text-danger f-12" *ngIf="linkedinerrormsg">{{linkedinerrormsg}}</p>
  </div>
  <div class=" position-relative">
    <div class="horizontal-line"></div>
    <span class="or">OR</span>
  </div>
  <div class="d-flex align-items-center mb-3">
    <div class="linkedin-label">
      <i class="fa fa-file-user"></i>
    </div>
    <div>
      <p class="f-12 font-weight-500" style="margin-bottom: 3px;">Upload Resume</p>
      <p class="f-12 text-9696 mb-0">Share the Resume of your benchmark candidate and we’ll show you similar profiles.
      </p>
    </div>
  </div>
  <div class="uploadResume mb-4" [ngClass]="{disabledNoOfCasesDiv:linkedinurl}">
    <div class="text-center" *ngIf="!uploadedFilename">
      <div>
        <p class="font-weight-500 text-bluex mb-0">Drag and Drop Resume here</p>
      </div>
    </div>
    <input data-testid="auto-app-similar-candidates-input-2" type="file" *ngIf="!uploadedFilename" #document (change)="uploadFile($event)"
      accept=".doc,.docx,.txt,.pdf, .dot,.rtf,.odt,.htm,.html">
    <div class="text-center d-flex" *ngIf="uploadedFilename" (click)="resetFormFields()">
      <img src="../../assets/paperclip.png" style="height: 18px; width: 18px;" />
      {{ uploadedFilename }}
      <p class="f-14 font-weight-600 text-webbtree-green ml-2 pointer mb-0" *ngIf="uploadedFilename">Remove</p>
    </div>
  </div>
  <div class="d-flex">

    <div class="errorMessage" *ngIf="resumeUploadErrorMessage.length">{{resumeUploadErrorMessage}}</div>
    <div>
      <p *ngIf="specialCharaterError" [ngClass]="['text-left f-12','my-1','text-danger']">
        Filename should not contain any special characters
      </p>
      <p *ngIf="incorrectFileFormat" [ngClass]="['text-left f-12','my-1','text-danger']">
        File type should be .doc or .pdf or .docx or .txt
      </p>
      <p *ngIf="fileSizeLimitExceeded" [ngClass]="['text-left f-12','my-1','text-danger']">
        The uploaded file exceeds the maximum allowed size of 5MB. Please upload a smaller file.
      </p>
    </div>
    <button data-testid="auto-app-similar-candidates-button-1" class="btn-trms-medium ms-auto px-4" *ngIf="linkedinurl" (click)="getdetailsFromLinkedin()">
      <span [ngClass]="{ 'spinner-border text-light': jdDataLoading }"
        [ngStyle]="{ 'width: 20px; height: 20px;': jdDataLoading }">
        {{jdDataLoading ? '' : 'Save & Next'}}
      </span>
    </button>
    <button data-testid="auto-app-similar-candidates-button-2" class="btn-trms-medium ms-auto px-4" *ngIf="uploadedFilename"
      (click)="openSimilarCandidateFilters('similar-candidate-resume-upload')" [disabled]="disableSimilarBtn"
      [ngStyle]="{'opacity': disableSimilarBtn ?  '0.65' : '1' }">
      <span [ngClass]="{ 'spinner-border text-light': jdDataLoading }"
        [ngStyle]="{ 'width: 20px; height: 20px;': jdDataLoading }">
        {{jdDataLoading ? '' : 'Save & Next'}}
      </span>
    </button>
    <button data-testid="auto-app-similar-candidates-button-3" class="btn-trms-medium ms-auto px-4" *ngIf="!uploadedFilename && !linkedinurl"
      [disabled]="!uploadedFilename && !linkedinurl"
      [ngStyle]="{'opacity': !uploadedFilename && !linkedinurl ?  '0.65' : '1'}">
      <span [ngClass]="{ 'spinner-border text-light': jdDataLoading }"
        [ngStyle]="{ 'width: 20px; height: 20px;': jdDataLoading }">
        {{jdDataLoading ? '' : 'Save & Next'}}
      </span>
    </button>
  </div>
</div>

<ng-template #showLinkedinGuide>
  <div class="modal-header b pb-0 d-flex align-items-start">
    <span class="modal-title font-weight-500"> Seems like the LinkedIn URL is not found. But we've got you covered,
      follow the below steps (as video):</span>
    <button data-testid="auto-app-similar-candidates-button-4" type="button" class="no-outline-border-btn p-1" data-dismiss="modal" aria-label="Close"
      (click)="modalService.dismissAll()">
      <span aria-hidden="true"><i class="fa-solid fa-xmark"></i></span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row mt-3">
      <div class="col d-flex justify-content-center align-items-center">
        <img src="../../../assets/nl-search/linkedin_url_tutorial.gif" class="img-fluid" alt="LinkedIn Video Guide"
          srcset="">
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <button data-testid="auto-app-similar-candidates-button-5" class="mt-3 btn-trms-medium" (click)="modalService.dismissAll()">Close</button>
    </div>
  </div>
</ng-template>

<ng-template #uploadlinkedin>
  <div id="confirmSubmit">
    <div class="d-flex justify-content-between px-3 pt-3 pb-0">
      <h5 class="modal-title f-14 font-weight-600 text-defualt" id="createTalentTitle">Paste Linkedin URL</h5>
      <span (click)="dismiss()">
        <i class="fas fa-times"></i>
      </span>
    </div>
    <div class="modal-body ">
      <div class="mb-4">
        <div class="">
          <input data-testid="auto-app-similar-candidates-input-3" type="text" class="wc-form-control nobg linkedinurlinput" placeholder="Paste linkedin URL"
            [(ngModel)]="linkedinurl">
          <p class="text-danger f-12" *ngIf="linkedinerrormsg">{{linkedinerrormsg}}</p>
        </div>
      </div>

      <div class="d-flex">
        <button data-testid="auto-app-similar-candidates-button-6" class="btn-trms-medium ml-auto" (click)="getdetailsFromLinkedin()">Similar
          Candidates22</button>
      </div>
    </div>

  </div>
</ng-template>

<ng-template #uploadResume>
  <div id="confirmSubmit">
    <div class="d-flex justify-content-between px-3 pt-3 pb-0">
      <h5 class="modal-title f-14 font-weight-600 text-defualt" id="createTalentTitle">Upload Resume</h5>
      <span (click)="dismiss()">
        <i class="fas fa-times"></i>
      </span>
    </div>


    <div class="modal-body ">
      <p class="f-14 text-9696">
        Share the Resume of your benchmark candidate and we’ll show you similar profiles.
      </p>

      <div class="uploadResume mb-4">
        <div class="text-center" *ngIf="!uploadedFilename">
          <div class="mb-4">
            <img src="../../../assets/images/resumepng.png" alt="">
          </div>
          <div>
            <p class="font-weight-600 text-bluex mb-0">Drag and Drop Resume file here</p>
          </div>
        </div>
        <input data-testid="auto-app-similar-candidates-input-4" type="file" *ngIf="!uploadedFilename" #document (change)="uploadFile($event)"
          accept=".doc,.docx,.txt,.pdf,.dot">
        <div class="text-center d-flex mt-3" *ngIf="uploadedFilename" (click)="resetFormFields()">
          <img src="../../assets/paperclip.png" style="height: 18px; width: 18px;" />
          {{ uploadedFilename }}
          <p class="f-14 font-weight-600 text-webbtree-green ml-2 pointer" *ngIf="uploadedFilename">Remove</p>
        </div>
      </div>
      <div class="d-flex">
        <button data-testid="auto-app-similar-candidates-button-7" class="ml-auto btn-trms-medium" (click)="openSimilarCandidateFilters('similar-candidate-resume-upload')"
          [disabled]="disableSimilarBtn" [ngStyle]="{'cursor': disableSimilarBtn ? 'not-allowed' : 'pointer' }">Similar
          Candidates33</button>
      </div>
    </div>

  </div>
</ng-template>
